// Slick Slider
$(document).ready(function(){

 
  // Header Slider
	$('.header-slider').each(function () {
		var slider = $(this);
		if (slider.hasClass('autoplay')) {
			var autoplayValue = true;
			var infiniteValue = true;
		} else {
			var autoplayValue = false;
			var infiniteValue = false;
		}

		slider.slick({
      arrows: false,
      dots: true,
      fade: true,
      infinite: infiniteValue,
			slidesToShow: 1,
			autoplay: autoplayValue,
			autoplaySpeed: 5000,
		});
		
	});  

	// Teaser Slider
	$('.teaser-slider').each(function () {
		var slider = $(this);
		function positionSliderTeaserArrows(slider) {
			var imgHeight = slider.find('.img-outer').first().outerHeight();
			var positionTop = (imgHeight / 2) + 'px';
			slider.find('.slick-prev, .slick-next').css('top', positionTop);
			//console.log('ArrowsTop: '+positionTop);
		}
  	slider.slick({
      infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: false,
			responsive: [
				{
					breakpoint: 1380,
					settings: {
						infinite: false,
						slidesToShow: 2,
						slidesToScroll: 1,
						dots: true
					}
				},
				{
					breakpoint: 992,
					settings: {
						infinite: false,
						slidesToShow: 2,
						slidesToScroll: 1,
						dots: true
					}
				},
				{
					breakpoint: 768,
					settings: {
						infinite: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true
					}
				}
			]
		});
		slider.on('setPosition', function (e) {
			positionSliderTeaserArrows(slider);
			//console.log('SetPosition');
		});
	});  
 
  // Product Slider ALT
	//$('.product-slider').each(function () {
  //	var slider = $(this);
  //	slider.slick({
  //    arrows: true,
  //    dots: false,
  //    slidesToShow: 4,
  //    infinite: false,
  //    responsive: [
  //      {
  //        breakpoint: 1200,
  //        settings: {
  //          arrows: true,
  //          dots: false,
  //          slidesToShow: 3,
  //          infinite: false
  //        }
  //      },
  //      {
  //        breakpoint: 992,
  //        settings: {
  //          arrows: true,
  //          dots: false,
  //          slidesToShow: 2,
  //          infinite: false
  //        }
  //      },
  //      {
  //        breakpoint: 768,
  //        settings: {
  //          arrows: true,
  //          dots: false,
  //          slidesToShow: 2,
  //          infinite: false
  //        }
  //      },
  //      {
  //        breakpoint: 500,
  //        settings: {
  //          arrows: true,
  //          dots: false,
  //          slidesToShow: 1,
  //          infinite: false
  //        }
  //      }
  //    ]
  //	});
	//});  

	// Product Slider
	$('.product-slider').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: true,
      dots: false,
			slidesToShow: 3,
			slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: true,
            dots: false,
						slidesToShow: 2,
						slidesToScroll: 1,
            infinite: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            dots: false,
						slidesToShow: 1,
						slidesToScroll: 1,
            infinite: false
          }
        }
      ]
  	});
	});  
	//$('.product-slider').each(function () {
  //	var slider = $(this);
  //	slider.slick({
  //    arrows: true,
  //    dots: false,
	//		//slidesToShow: 3,
	//		slidesToScroll: 1,
	//		//centerMode: true,
	//		variableWidth: true,
  //    infinite: false,
  //    responsive: [
  //      {
  //        breakpoint: 992,
  //        settings: {
  //          arrows: true,
  //          dots: false,
	//					//slidesToShow: 2,
	//					slidesToScroll: 1,
	//					//centerMode: true,
	//					variableWidth: true,
  //          infinite: false
  //        }
  //      },
  //      {
  //        breakpoint: 500,
  //        settings: {
  //          arrows: true,
  //          dots: false,
	//					//slidesToShow: 1,
	//					slidesToScroll: 1,
	//					//centerMode: true,
	//					variableWidth: true,
  //          infinite: false
  //        }
  //      }
  //    ]
  //	});
	//});  

});